// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const FORUM_TOPIC_EDIT = "Uprav popis a fotku";
export const SEO_TITLE_FORUM_TOPIC_INFO_category = "O f\u00f3re %(category)s";
export const SEO_TITLE_FORUM_TOPICS = "V\u0161etko, \u010do mami\u010dky zauj\u00edma";
